export const en = {
  'addresses.title': 'Sign-in addresses',
  'addresses.description': 'Members sign in on the site, floor staff at service. and owners and managers at admin. in front of it. On a custom domain all three open as soon as the site does.',
  'addresses.members': 'Members',
  'addresses.staff': 'Reception, trainers, massage therapists, bar, accounting, marketing, shift managers',
  'addresses.management': 'Owners, admins, gym general managers, HR managers and branch managers',
  'addresses.off': 'Sign-in by address is off on this deployment, so everyone still signs in at Bulk’s own address until it is switched on.',
  'addresses.none': 'Verify a domain first; its addresses show here.',
};

export const ka: Record<keyof typeof en, string> = {
  'addresses.title': 'შესვლის მისამართები',
  'addresses.description': 'წევრები შედიან საიტზე, დარბაზის თანამშრომლები service.-ზე, მფლობელები და მენეჯერები კი admin.-ზე მის წინ. საკუთარ დომენზე სამივე მისამართი იხსნება, როგორც კი საიტი გაიხსნება.',
  'addresses.members': 'წევრები',
  'addresses.staff': 'რეცეფცია, ტრენერები, მასაჟისტები, ბარი, ბუღალტერია, მარკეტინგი, ცვლის მენეჯერები',
  'addresses.management': 'მფლობელები, ადმინისტრატორები, დარბაზის გენერალური მენეჯერები, HR მენეჯერები და ფილიალის მენეჯერები',
  'addresses.off': 'ამ სისტემაში მისამართით შესვლა გამორთულია, ამიტომ ყველა ჯერ კიდევ Bulk-ის მისამართზე შედის, სანამ არ ჩაირთვება.',
  'addresses.none': 'ჯერ დაადასტურეთ დომენი; მისი მისამართები აქ გამოჩნდება.',
};
